import React from "react";
import ReactDOM from "react-dom";
import WPHeader from "./components/WPHeader";
import WPStore from "./components/WPStore";
import WPProduct from "./components/WPProduct";
import WPCheckout from "./components/WPCheckout";
// import WPRecoverPw from "./components/WPRecoverPw";
import WPProfile from "./components/WPProfile";
import WPLogin from "./components/WPLogin";

class OutdareGo {

	renderStore() {
		ReactDOM.render(<WPStore/>, document.getElementById('go-store'));
	}

	renderHeader() {
		ReactDOM.render(<WPHeader/>, document.getElementById('go-header'));
	}

	renderCheckout() {
		ReactDOM.render(<WPCheckout/>, document.getElementById('go-checkout'));
	}

	renderProduct() {
		ReactDOM.render(<WPProduct/>, document.getElementById('go-product'));
	}

	// renderRecover() {
	// 	ReactDOM.render(<WPRecoverPw/>, document.getElementById('go-recover'));
	// }

	renderProfile() {
		ReactDOM.render(<WPProfile/>, document.getElementById('go-profile'));
	}

	renderLogin() {
		ReactDOM.render(<WPLogin/>, document.getElementById('go-login'));
	}
}

export default new OutdareGo();
